
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/paquera",
      function () {
        return require("private-next-pages/paquera/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/paquera"])
      });
    }
  